export const standardColors = [
  { id: '#fff9fb', name: 'Color 1' },
  { id: '#FFE7CB', name: 'Color 2' },
  { id: '#fff4fb', name: 'Color 3' },
  { id: '#FF9357', name: 'Color 4' },
  { id: '#ffeffe', name: 'Color 5' },
  { id: '#F4B0C0', name: 'Color 6' },
  { id: '#ffdfe5', name: 'Color 7' },
  { id: '#FF80A7', name: 'Color 8' },
  { id: '#ffdaee', name: 'Color 9' },
  { id: '#FECBFF', name: 'Color 10' },
  { id: '#ffd2ff', name: 'Color 11' },
  { id: '#FC7DFF', name: 'Color 12' },
  { id: '#f9ceff', name: 'Color 13' },
  { id: '#D3A4FE', name: 'Color 14' },
  { id: '#e6caff', name: 'Color 15' },
  { id: '#C17BFF', name: 'Color 16' },
  { id: '#d0c6ff', name: 'Color 17' },
  { id: '#C2D0FF', name: 'Color 18' },
  { id: '#c3cdff', name: 'Color 19' },
  { id: '#93A5FF', name: 'Color 20' },
  { id: '#c0e0ff', name: 'Color 21' },
  { id: '#87DBFF', name: 'Color 22' },
  { id: '#bdf4ff', name: 'Color 23' },
  { id: '#2CBBF8', name: 'Color 24' },
  { id: '#baffff', name: 'Color 25' },
  { id: '#BCFFFB', name: 'Color 26' },
  { id: '#b7fff1', name: 'Color 27' },
  { id: '#3BFFFF', name: 'Color 28' },
  { id: '#b4ffd8', name: 'Color 29' },
  { id: '#7DFFD0', name: 'Color 30' },
  { id: '#b2ffbe', name: 'Color 31' },
  { id: '#0DD38C', name: 'Color 32' },
  { id: '#bcffb0', name: 'Color 33' },
  { id: '#B1FFA2', name: 'Color 34' },
  { id: '#d2ffae', name: 'Color 35' },
  { id: '#83FF6D', name: 'Color 36' },
  { id: '#e9ffac', name: 'Color 37' },
  { id: '#FBFFD0', name: 'Color 38' },
  { id: '#ffffaa', name: 'Color 39' },
  { id: '#FEFE6B', name: 'Color 40' },
  { id: '#f49191', name: 'Color 41' },
  { id: '#FF6666', name: 'Color 42' },
];
